module.exports = __webpack_public_path__ + "img/小芋頭企業戰略系統S.37e2b093.png";